import {Injectable} from '@angular/core';
import {ActivityDTO} from '../data/activityDTO';
import {EventEx} from '../../app-common/data/Event';
import {ApiService} from '../../app-common/services/server/api.service';
import {LogLevel} from '../../logging/data/logLevel';
import {LogSourceType} from '../../logging/data/logSourceType';
import {LogSource} from '../../logging/data/logSource';
import {LoggerService} from '../../logging/services/logger.service';

@Injectable({
  providedIn: 'root'
})
export class ActivityLogService {

  firstOpenEvent: EventEx = new EventEx();
  hasLogOpenedYet: boolean = false;

  constructor(public apiService: ApiService,
              private loggerService: LoggerService) {
    this.apiService = apiService;
  }

  async getActivityLogsAfter(date: Date) {
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.ActivityLogService, 'Getting activity logs after ' + date.toUTCString());
    const response = this.apiService.applicationApiClient.getWithParams<ActivityDTO[]>('ActivityLog/GetActivityLog', {date: date.toUTCString()});
    return response;
  }
}
